import {BigNumber} from "bignumber.js";

// 加
export function add(a, b) {
    a = BigNumber(a);
    b = BigNumber(b);
    return a.plus(b).toNumber();   //结果需要用toNumber转为普通数字
}
// 减
export function minus(a, b) {
    a = BigNumber(a);
    b = BigNumber(b);
    return a.minus(b).toNumber();
}
// 乘
export function times(a, b) {
    a = BigNumber(a);
    b = BigNumber(b);
    return a.multipliedBy(b).toNumber();
}
// 除
export function div(a, b) {
    a = BigNumber(a);
    b = BigNumber(b);
    return a.dividedBy(b).toNumber();
}
// 多个数求和
export function multiAdd(...params) {
    let data = BigNumber(0);
    for (let index = 0; index < params.length; index++) {
      const element = BigNumber(params[index]);
      data = data.plus(element);
    }
    return data.toNumber();
}
  